/* eslint-disable */
import { ref } from 'vue';
import { auth } from '@/firebase';
import { ReconnectingEventSource } from '@/api/ReconnectingEventSource';
import { useStore } from 'vuex';

const URL_STREAM = 'https://api.meshcommengineering.com/api/v1/stream/user';

export function useUserStream() {
    const store = useStore();
    const isConnected = ref(false);
    let es = null;

    function handleUserDoc(event) {
        try {
            const docs = JSON.parse(event.data);
            const doc = Array.isArray(docs) ? docs[0] : docs;
            if (doc) {
                const { id, ...fields } = doc;
                store.dispatch('mergeUser', fields);
            }
        } catch (err) {
            console.error('useUserStream: failed to parse message', err);
        }
    }

    function start(uid) {
        if (es) return;

        es = new ReconnectingEventSource(`${URL_STREAM}/${uid}`, {
            getHeaders: async () => {
                const token = await auth.currentUser.getIdToken();
                return { Authorization: `Bearer ${token}` };
            },
        });

        es.addEventListener('connected', () => { isConnected.value = true; });
        es.addEventListener('added', handleUserDoc);
        es.addEventListener('modified', handleUserDoc);
        es.onerror = () => { isConnected.value = false; };
    }

    function stop() {
        if (es) {
            es.close();
            es = null;
        }
        isConnected.value = false;
    }

    return { start, stop, isConnected };
}
